import { IKnmForm } from '../../../KnmPackage/MainModule/interfaces/IKnmForm';
import { KnmKindCodesEnum } from '../../../APIPackage/DictionariesModule/enums/KnmKindCodesEnum';

interface IMarkedField {
  appendShowMarkCondition?: (values: IKnmForm) => boolean;
}

export const isSectionRequiredForNextStatusesInFillInProcess = (
  sectionName: string | undefined,
  values: IKnmForm,
): boolean => {
  if (!sectionName || !sectionsRequiredForNextStatusesInFillInProcess[sectionName]) {
    return false;
  }

  const markedSection = sectionsRequiredForNextStatusesInFillInProcess[sectionName];

  return !markedSection.appendShowMarkCondition || markedSection.appendShowMarkCondition(values);
};

const sectionsRequiredForNextStatusesInFillInProcess: Record<string, IMarkedField> = {
  decision: {
    appendShowMarkCondition: values => !values.fioSigner || !values.titleSigner,
  },
  dates: {
    appendShowMarkCondition: values =>
      !values.durationDays ||
      (values.kindKnm?.code !== KnmKindCodesEnum.DP && !values.directDurationDays && !values.durationHours),
  },
  interactionCategorySection: {
    appendShowMarkCondition: values =>
      !values.interactionCategory &&
      (values.kindKnm?.code === KnmKindCodesEnum.KZ ||
        values.kindKnm?.code === KnmKindCodesEnum.MZ ||
        values.kindKnm?.code === KnmKindCodesEnum.IV ||
        values.kindKnm?.code === KnmKindCodesEnum.VP),
  },
};
